import { useCallback, useMemo, useState } from "react";
import api from "../../../../utils/api";
import { EventosPg } from "../../../../types";

export type ResponseMembrosCheckin = {
  listAll: EventosPg[] | []
  reset: VoidFunction
  nextPagina: VoidFunction
  getWithParams: () => void
  list: EventosPg[]
  pagina: number
  getSearchPerMinister: (e: any) => void
  pesquisaPorMinisterio: string
  params?: any
  alterParams?: (field: 'idsede' | 'inscricao' | 'ativo', value: any) => void
}

const GetMembrosBatizado = (): ResponseMembrosCheckin => {

  const [listCheckinMembros, setListCheckinMembros] = useState<EventosPg[]>([]);
  const [list, setList] = useState<EventosPg[]>([]);
  const [pagina, setPagina] = useState<number>(0);
  const [pesquisaPorMinisterio, setPesquisaPorMinisterio] = useState<string>('');

  const [params, setParams] = useState<{idsede: number, inscricao: string, ativo: boolean | string}>();

  const alterParams = (field: 'idsede' | 'inscricao' | 'ativo', value: any) => setParams((val) => ({...val, [field]: value}))

  const getSearchPerMinister = (event: any) => setPesquisaPorMinisterio(event?.target?.value);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const reset = async () => {
    setParams(undefined);
    getList();
  }

  const getWithParams = () => {
    api.get<EventosPg[]>('view/batismo', { params: { ...params, idgrupo: 7 } })
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }

  const getList = useCallback(async () => {
    api.get<EventosPg[]>('view/batismo')
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }, []);

  useMemo(() => {
    getList()
  }, [])


  return {
    listAll: listCheckinMembros,
    reset,
    params,
    nextPagina,
    alterParams,
    list,
    pagina,
    getWithParams,
    getSearchPerMinister,
    pesquisaPorMinisterio
  };
}

export default GetMembrosBatizado;
